export default __webpack_public_path__ + "static/media/x-blueLogo.fa90abe2.svg";